<template>
  <div class="material-management">
    <div class="volume-box">
      <span class="title-box">素材库已使用：{{ bytesToSize(usedSpace) }}</span>
    </div>
    <el-tabs
      v-model="isComponent"
      @tab-click="handleActive"
      v-if="
        isComponent === 'ImageComp' ||
        isComponent === 'VideoComp' ||
        isComponent === 'AudioComp' ||
        isComponent === 'DocComp'
      "
    >
      <el-tab-pane label="图片" name="ImageComp"></el-tab-pane>
      <el-tab-pane label="视频" name="VideoComp"></el-tab-pane>
      <el-tab-pane label="音频" name="AudioComp"></el-tab-pane>
      <el-tab-pane label="文档" name="DocComp"></el-tab-pane>
    </el-tabs>
    <component :is="isComponent" v-bind="$attrs" v-on="$listeners" />
  </div>
</template>
<script>
import { GetSpaceInfo /* 查询空间使用量 */ } from '@/api/releaseManagement';
import ImageComp from './components/image';
import VideoComp from './components/video';
import AudioComp from './components/audio';
import DocComp from './components/document';
import { bytesToSize } from '@/utils/util';

export default {
  name: 'MaterialManagement',
  components: {
    ImageComp,
    VideoComp,
    AudioComp,
    DocComp,
  },
  data() {
    return {
      active: '0',
      isComponent: 'ImageComp',
      usedSpace: 0,
      bytesToSize,
    };
  },
  computed: {
    enterpriseId() {
      return this.$store.getters['user/getEnterpriseId'];
    },
  },
  watch: {
    $route: {
      handler(route) {
        const { componentName } = route.query;
        componentName ? (this.isComponent = componentName) : (this.isComponent = 'ImageComp');
      },
      // 深度观察监听
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getSpaceInfo();
  },
  mounted() {},
  // beforeRouteLeave(to, from, next) {
  //   // 导航离开该组件的对应路由时调用
  //   // 可以访问组件实例 `this`
  //   console.log('beforeRouteLeave', to, from);
  //   next(false);
  // },
  methods: {
    handleActive(tab) {
      this.isComponent = tab.name || 'ImageComp';
    },
    async getSpaceInfo() {
      try {
        const res = await GetSpaceInfo({
          EnterpriseID: this.enterpriseId,
        });
        console.log(res);
        this.usedSpace = res.Used;
      } catch (err) {
        console.log('error', err);
      }
    },
  },
};
</script>
<!--这里不要加scoped，会后悔的-->
<style lang="scss">
.material-management {
  position: relative;
  .volume-box {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.02);
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    width: 272px;
    height: 57px;
    box-sizing: border-box;
    padding: 10px 16px;
    position: absolute;
    top: -36px;
    right: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    .title-box {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #626366;
    }
  }
  .el-input {
    width: auto;
  }
  .material-management-common {
    // 条件栏
    .nav {
      .nav-up {
        .query-bar {
          .query-left {
            display: inline-block;
          }
          .query-right {
            float: right;
          }
        }
      }
      .nav-down {
        .img-text {
          font-size: 16px;
          color: #313233;
        }
      }
    }

    // 表格----------------
    // 标题
    .title {
      display: flex;
      align-items: center;
      .table-img {
        width: 80px;
        height: 80px;
        margin-right: 15px;
        border-radius: 4px;
        object-fit: contain;
        cursor: pointer;
      }
    }
    // 操作
    .action {
      a {
        text-decoration: none;
        color: #2f96ff;
      }
    }
    //分页
    .pagination {
      margin-top: 12px;
      text-align: right;

      & ::v-deep .el-pager li.number {
        color: #606266;
      }

      & ::v-deep .el-pager li.active {
        color: #2f96ff !important;
      }

      & ::v-deep .el-input__inner {
        width: 46px;
        border-radius: 3px;
        height: 24px;
      }
    }
  }
}
</style>
